// 치과 의뢰서 상세(ViewOrder) — 「오늘 접수」 연결 표시 + [연결 해제] (2026-10-03 대표 추가 지시: 잘못 연결 시 해제)
// 표시 조건: 플래그 deskReception(strict) ON && 의뢰서에 receptionId 가 있음(서버 linkOrderToReception 이 기록 — 클라이언트는 쓰지 않음).
// 해제 = unlinkOrderReception({ orderId }) — 서버가 workOrders.receptionId 와 접수의 orderIds 를 함께 정리. 인쇄 제외(no-print)
import React, { useEffect, useState } from 'react';
import { getFeatures, isDeskReceptionOn } from '../../utils/features';
import { unlinkOrderReception } from '../../services/receptionApi';
import { receptionDeskError } from '../../utils/deskReception';

function OrderReceptionLink({ order }) {
    const [on, setOn] = useState(false);
    const [unlinked, setUnlinked] = useState(false);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');

    useEffect(() => {
        let alive = true;
        getFeatures().then(f => { if (alive) setOn(isDeskReceptionOn(f)); })
            .catch((e) => { console.error('[접수 연결] 플래그 조회 실패:', e?.message || e); if (alive) setOn(false); });
        return () => { alive = false; };
    }, []);

    if (!on || !order?.id || !order?.receptionId || unlinked) return null;

    const unlink = async () => {
        if (busy) return;
        if (!window.confirm('이 의뢰서와 접수 기록의 연결을 해제할까요? 접수 화면의 보철 이력에서 이 의뢰서가 빠집니다.')) return;
        setBusy(true); setErr('');
        try {
            await unlinkOrderReception(order.id);
            setUnlinked(true);
        } catch (e) {
            console.error('[접수 연결] 해제 실패:', e?.code || e?.message || e, e?.details?.code || '');
            setErr(receptionDeskError(e, '연결을 해제하지 못했습니다. 잠시 후 다시 시도해 주세요.'));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="no-print" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', fontSize: 12.5, color: '#0f6b5c', background: '#e2f0ec', border: '1px solid #a7d3c8', borderRadius: 8, padding: '6px 10px', margin: '8px 0' }}>
            <span>접수 기록과 연결된 의뢰서입니다.</span>
            <button type="button" disabled={busy} onClick={unlink}
                style={{ marginLeft: 'auto', border: '1px solid #a7d3c8', background: '#fff', color: '#0f6b5c', borderRadius: 6, padding: '2px 9px', fontSize: 11.5, cursor: 'pointer' }}>
                {busy ? '해제 중…' : '연결 해제'}
            </button>
            {err && <div style={{ width: '100%', color: '#8a2020' }}>{err}</div>}
        </div>
    );
}

export default OrderReceptionLink;
